import { useState } from 'react';
import { ToggleContext } from '../../Inventory/provider/context';

export default function ToggleProvider( {children} ) {
  const [toggleState, setToggleState] = useState('must_have'); // Initial state

  const updateToggleState = (value) => {
    setToggleState(value);
  };

  return (
    <ToggleContext.Provider value={{ toggleState, updateToggleState }}>
      {children}
    </ToggleContext.Provider>
  );
};